export default __webpack_public_path__ + "static/OpenSans-Italic-c2d26fca552c9a4d36893a14eea36df6.woff2";